import React from "react";
import Hero from "../../components/medical/Hero";
import HighlightedContactSection from "../../components/HighlightedContactSection";
import { CANDIDATE_REVIEWS } from "../../data/candidateReviewsData";

const SCROLL_DURATION = 40;

function ReviewCard({ quote, name, role }) {
  return (
    <div className="min-h-[140px] shrink-0 rounded-2xl border border-gray-200/80 bg-white p-6 shadow-[0_4px_20px_rgba(0,0,0,0.06)] transition-shadow hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)]">
      <p className="text-[15px] leading-relaxed text-gray-700">„{quote}"</p>
      <div className="mt-4 border-t border-gray-100 pt-4">
        <p className="font-semibold text-gray-900">{name}</p>
        <p className="text-sm text-gray-500">{role}</p>
      </div>
    </div>
  );
}

function ReviewColumn({ reviews, direction }) {
  const duplicated = [...reviews, ...reviews];

  return (
    <div className="group h-[560px] overflow-hidden md:h-[680px]">
      <div
        className="flex flex-col gap-5 group-hover:[animation-play-state:paused]"
        style={{
          animation: `scroll-${direction} ${SCROLL_DURATION}s linear infinite`,
        }}
      >
        {duplicated.map((review, i) => (
          <ReviewCard
            key={i}
            quote={review.quote}
            name={review.name}
            role={review.role}
          />
        ))}
      </div>
    </div>
  );
}

export default function CandidateFeedbackPage() {
  const columns = 4;
  const perColumn = Math.ceil(CANDIDATE_REVIEWS.length / columns);
  const columnData = Array.from({ length: columns }, (_, colIndex) =>
    CANDIDATE_REVIEWS.slice(colIndex * perColumn, (colIndex + 1) * perColumn)
  );

  return (
    <>
      <style>{`
        @keyframes scroll-up {
          0% { transform: translateY(0); }
          100% { transform: translateY(-50%); }
        }
        @keyframes scroll-down {
          0% { transform: translateY(-50%); }
          100% { transform: translateY(0); }
        }
      `}</style>
      <Hero title="Kandidatenfeedback" subheading="Was Kandidaten über uns sagen." />
      <section className="relative overflow-hidden bg-white py-16 md:py-20">
        <div className="container-app mx-auto">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {columnData.map((reviews, i) => (
              <ReviewColumn
                key={i}
                reviews={reviews}
                direction={i % 2 === 0 ? "up" : "down"}
              />
            ))}
          </div>
        </div>
        <HighlightedContactSection
          heading="Ihre Erfahrung mit uns teilen"
          description="Sie waren Kandidat bei uns und möchten Feedback geben? Wir freuen uns über Ihre Nachricht."
          buttonText="Jetzt Kontakt aufnehmen"
          sectionId="section-kandidatenfeedback-contact"
        />
      </section>
    </>
  );
}
